module.exports = __webpack_public_path__ + "static/image/company/m/image_vision_1@3x.jpg?b6ea4550";